import React from 'react';

export const IllinoisInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">City of Chicago</p>
        <p className="eds-l-mar-bot-1">
            <strong>Chicago Small Business Resiliency Loan Fund</strong> |&nbsp;
            <a
                href="https://www.chicagobusiness.com/government/lightfoot-100m-loan-fund-businesses-hit-coronavirus"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            $100M in loan funds available to businesses. Applications for the
            Chicago Small Business Resiliency Fund will begin to be accepted on
            March 31, 2020.
        </p>
    </div>
);
